<template>
  <form-dialog :value="value" @input="close($event)" :title="dialogTitle" @save="save" :can-save="canSave">
    <uploaded-response-details v-model="showResponseText"
                      @close="closeResponseDialog"
                      @download="downloadContent"
                      :endpoint="selectedEndpoint"
                      :endpoint-data="uploadedData"
    />
    <template>
      <v-container>
        <v-card color="#F5F5F5" elevation="0" >
          <v-select
                  :items="products"
                  label="Produkt"
                  v-model="selectedProduct"
                  item-text="name"
                  item-value="id"
                  v-on:change="productChanged"
                  persistent-hint
                  return-object
                  :disabled="uploadInProgress"
                  outlined
          ></v-select>
          <v-select
                  :items="endpoints"
                  label="Endpunkt"
                  v-model="selectedEndpoint"
                  item-text="name"
                  item-value="id"
                  persistent-hint
                  v-on:change="endpointChanged"
                  return-object
                  outlined
                  :disabled="uploadInProgress"
          ></v-select>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="4">
                <v-switch
                  v-model="uploadedActive"
                  label="Diesen Upload aktivieren"
              ></v-switch>
              </v-col>
              <v-col cols="12" md="2"></v-col>
              <v-col  v-if="this.uploadedData" cols="12" md="6" class="text-right">
                <v-btn
                color="primary"
                class="ma-2"
                dark
                @click="showClicked">
                  Anzeigen
                  <v-icon dark
                          right
                          >mdi-eye</v-icon>
                </v-btn>
                <v-btn
                  color="primary"
                  class="ma-2"
                  dark
                  @click="downloadContent">
                  Herunterladen
                  <v-icon dark
                          right
                          >mdi-download</v-icon>
                </v-btn>
              </v-col>
            </v-row>

          </v-card-text>

          <v-flex xs7 class="pt-6 primary--text">
           Sie können entweder eine Datei hochladen
          </v-flex>
          <v-row
              align="center"
          >
            <v-col
                md="6"
                offset-md="3"
            >
          <vue-dropzone
                  ref="myVueDropzone"
                  id="dropzone"
                  :options="dropzoneOptions"
                  @vdropzone-processing="dzDynamicUrl"
                  @vdropzone-file-added="dzFileAdded"
                  @vdropzone-removed-file="dzFileRemoved"
                  @vdropzone-sending="onBeforeSend"
                  @vdropzone-success="dzUploadSuccess"
                  @vdropzone-error="dzUploadError"
                  ></vue-dropzone>
            </v-col>
          </v-row>
          <v-flex xs7 class="pt-3 primary--text">
            oder den Response-Text im unteren Feld eingeben
          </v-flex>
            <v-row
                    align="center"
            >
              <v-col
                      md="6"
                      offset-md="3"
              >
                <v-textarea
                        outlined
                        name="input-7-4"
                        label="Response-Text"
                        v-model="responseText"
                        :disabled="textareaDisabled"
                ></v-textarea>
              </v-col>
            </v-row>
        </v-card>
      </v-container>
    </template>

  </form-dialog>
</template>
<!-- TODO change lang to ts instead js to enable typescript-->
<script lang="js">
import FormDialog from '../components/FormDialog'
import uploadedApi from '../api/uploaded'
import ErrorStore from "@/stores/ErrorStore";
import AuthStore from "../stores/AuthStore"
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import vkbeautify from 'vkbeautify';
import productsApi from "@/api/products";
import endpointsApi from "@/api/endpoints";
import config from '../config/index'
import UploadedResponseDetails from "@/components/UploadedResponseDetails";
import SortUtil from "@/utils/sortUitl";

export default {
  name: 'uploaded-details',
  components: { FormDialog, vueDropzone: vue2Dropzone, UploadedResponseDetails },
  data () {
    return {
      uploadedData: this.uploaded,
      products: this.uploaded ? [this.uploaded.product] : [],
      endpoints: this.uploaded ? [this.uploaded.endpoint] : [],
      selectedProduct: this.uploaded ? this.uploaded.product : this.product,
      selectedEndpoint: this.uploaded ? this.uploaded.endpoint : null,
      uploadInProgress: false,
      responseText: null,
      canSave: true,
      showResponseText: false,
      uploadedActive: this.uploaded ? this.uploaded.active : false
    }
  },
  props:{
    value: Boolean,
    uploaded: Object,
    product: Object
  },
  computed: {
    textareaDisabled () {
      return this.uploadInProgress
    },
    dialogTitle () {
      return this.uploadedData ? `${this.uploadedData.endpoint.name} | ${this.uploadedData.product.name}`: 'Neuen Upload erstellen'
    },
    prettyPrinted () {
      if (this.uploadedData && this.uploadedData.content) {
        switch (this.uploadedData.endpoint.expected_format) {
          case 'xml':
            try {
              return vkbeautify.xml(this.uploadedData.content)
            }
            catch (e) {
              return this.uploadedData.content
            }
          case 'json':
            try {
              return vkbeautify.json(this.uploadedData.content)
            }
            catch (e) {
              return this.uploadedData.content
            }
          default:
            return this.uploadedData.content
        }
      }
      return ''
    },
    uploadUrl () {
      return this.selectedEndpoint ? `${config.apiUrl}uploaded/${this.selectedEndpoint.id}/create_or_update` : ''
    },
    dropzoneOptions () {
      return {
        url: this.uploadUrl,
        addRemoveLinks: true,
        thumbnailWidth: 150,
        headers: {
          'Authorization': `Bearer ${AuthStore.state.accessToken}`
        },
        paramName: 'file',
        timeout: 100000,
        maxFiles: 1,
        acceptedFiles:`.${this.fileExtension}`,
        autoProcessQueue: false
      }
    },
    fileExtension () {
      if (this.uploadedData && this.uploadedData.endpoint) {
        switch (this.uploadedData.endpoint.expected_format) {
          case 'json':
            return 'json'
          case 'xml':
            return 'xml'
          default:
            return 'txt'
        }
      } else if(this.selectedEndpoint && this.selectedEndpoint.expected_format) {
        switch (this.selectedEndpoint.expected_format) {
          case 'json':
            return 'json'
          case 'xml':
            return 'xml'
          default:
            return 'txt'
        }
      }
      return 'txt'
    }
  },
  watch: {
    responseText(newVal) {
      const textLength = newVal.length
      if (textLength > 0) {
        this.clearDropzone()
      }
    }
  },
  mounted () {
    if ([undefined, null].includes(this.uploaded)) {
      this.fetchProducts()
    }
  },
  methods: {
    closeResponseDialog () {
      this.showResponseText = false
    },
    dzFileAdded () {
      this.uploadInProgress = true
      this.responseText = null
    },
    dzFileRemoved () {
      this.uploadInProgress = false
    },
    dzUploadSuccess (file, response) {
      this.uploadInProgress = false
      this.uploadedData = response
      uploadedApi.createOrUpdateUploaded(this.selectedEndpoint.id,
          {'uploaded_id': this.uploadedData ? this.uploadedData.id : -1, active: this.uploadedActive,
            direct: this.selectedEndpoint.direct ? true : null  }
      ).then(r => {
        ErrorStore.showErrorMessage('Erfolgreich gespeichert', 'Info')
        this.uploadedData = r.data
      })
    },
    onBeforeSend (file, xhr, formData) {
      formData.append('uploaded_id', this.uploadedData ? this.uploadedData.id : -1)
      if(this.selectedEndpoint.direct){
        formData.append('direct', true)
      }
    },
    dzUploadError (_, response) {
      this.uploadInProgress = false
      if(typeof response === 'object') {
        const errorDisplay = document.querySelectorAll('[data-dz-errormessage]');
        if(Object.prototype.hasOwnProperty.call(response.message, 'detail')){
          errorDisplay[errorDisplay.length - 1].innerHTML = response.message.detail
        } else {
          errorDisplay[errorDisplay.length -1].innerHTML = 'Keine Berechtigung'
        }

      }
    },
    fetchProducts () {
      productsApi.getProducts().then((r) => {
        this.products = SortUtil.sortedNames(r.data)
        if ([undefined, null].includes(this.selectedProduct)) {
          this.selectedProduct =  this.products[0]
        }
        this.fetchEndpoints()
      })
    },
    fetchEndpoints () {
      endpointsApi.getEndpoints(this.selectedProduct.identifier).then((r) => {
        this.endpoints = r.data.filter(ep => {
          return ep && ep.endpoint_flavor.name === 'live'
          })
        this.selectedEndpoint = this.endpoints[0]
      })
    },
    clearDropzone () {
      this.$refs.myVueDropzone.removeAllFiles()
    },
    close() {
      if (this.uploadInProgress) {
        ErrorStore.showErrorMessage('Bitte speichern Sie bevor sie die Seite verlassen oder löschen Sie die hochgeladene Datei', 'Hinweis')
      } else {
        this.clearDropzone()
        this.$emit('close')
        this.uploadedData = null
        this.responseText = null
        this.uploadedActive = false
      }
    },
    save () {
      const acceptedFiles = this.$refs.myVueDropzone.getAcceptedFiles()
      if(acceptedFiles && acceptedFiles.length) {
        this.$refs.myVueDropzone.processQueue()
      } else {
          const data = {
            'uploaded_id': this.uploadedData ? this.uploadedData.id : -1,
            direct: this.selectedEndpoint.direct ? true : null,
            active: this.uploadedActive
          }
          if(this.responseText) {
            data['content'] = this.responseText
          }
          uploadedApi.createOrUpdateUploaded(this.selectedEndpoint.id,
              data
          ).then(r => {
            ErrorStore.showErrorMessage('Erfolgreich gespeichert', 'Info')
            this.uploadedData = r.data
          })
          .catch(r => {
            ErrorStore.showError(r.response.data)
          })
      }
    },
    productChanged () {
      this.clearDropzone()
      this.endpoints = []
      this.fetchEndpoints()
    },
    endpointChanged () {
      this.clearDropzone()
    },
    dzDynamicUrl () {
      this.$refs.myVueDropzone.setOption('url', this.uploadUrl);
    },
    showClicked () {
      this.showResponseText = true
    },
    downloadContent () {
      const link = document.createElement("a");
      link.download = name;
      const productIdentifier = this.selectedEndpoint ? this.selectedEndpoint.product.identifier : -1
      const endpointId = this.selectedEndpoint ? this.selectedEndpoint.id : -1
      const uploadedId = this.uploadedData ? this.uploadedData.id : -1
      link.href = `${config.apiUrl}product/${productIdentifier}/uploaded/${endpointId}/file/${uploadedId}`
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}
</script>
